function getNombreMes(numeroMes) {
  var nombreMes = "";
  if (numeroMes == 1) {
    nombreMes = "Enero";
  }
  if (numeroMes == 2) {
    nombreMes = "Febrero";
  }
  if (numeroMes == 3) {
    nombreMes = "Marzo";
  }
  if (numeroMes == 4) {
    nombreMes = "Abril";
  }
  if (numeroMes == 5) {
    nombreMes = "Mayo";
  }
  if (numeroMes == 6) {
    nombreMes = "Junio";
  }
  if (numeroMes == 7) {
    nombreMes = "Julio";
  }
  if (numeroMes == 8) {
    nombreMes = "Agosto";
  }
  if (numeroMes == 9) {
    nombreMes = "Septiembre";
  }
  if (numeroMes == 10) {
    nombreMes = "Octubre";
  }
  if (numeroMes == 11) {
    nombreMes = "Noviembre";
  }
  if (numeroMes == 12) {
    nombreMes = "Diciembre";
  }

  return nombreMes;
}
function getNombreCorto(numeroMes) {
  var nombreMes = "";
  if (numeroMes == 1) {
    nombreMes = "Ene";
  }
  if (numeroMes == 2) {
    nombreMes = "Feb";
  }
  if (numeroMes == 3) {
    nombreMes = "Mar";
  }
  if (numeroMes == 4) {
    nombreMes = "Abr";
  }
  if (numeroMes == 5) {
    nombreMes = "May";
  }
  if (numeroMes == 6) {
    nombreMes = "Jun";
  }
  if (numeroMes == 7) {
    nombreMes = "Jul";
  }
  if (numeroMes == 8) {
    nombreMes = "Ago";
  }
  if (numeroMes == 9) {
    nombreMes = "Sep";
  }
  if (numeroMes == 10) {
    nombreMes = "Oct";
  }
  if (numeroMes == 11) {
    nombreMes = "Nov";
  }
  if (numeroMes == 12) {
    nombreMes = "Dic";
  }

  return nombreMes;
}

export function cleanText(text) {
  var res = text.replaceAll("%20", " ");
  res = res.replaceAll("%C3%B3", "ó");
  res = res.replaceAll("%C3%A1", "á");
  res = res.replaceAll("%C3%A9", "é");
  res = res.replaceAll("%C3%AD", "í");
  res = res.replaceAll("%C3%BA", "ú");
  res = res.replaceAll("%C3%93", "Ó");
  res = res.replaceAll("%C3%81", "Á");
  res = res.replaceAll("%C3%89", "É");
  res = res.replaceAll("%C3%8D", "Í");
  res = res.replaceAll("%C3%9A", "Ú");
  res = res.replaceAll("%C2%B4", "´");
  res = res.replaceAll("%C2%A1", "¡");
  res = res.replaceAll("%C2%BF", "¿");
  res = res.replaceAll("%C2%AB", "«");
  res = res.replaceAll("%C2%BB", "»");
  res = res.replaceAll("%C3%91", "Ñ");
  res = res.replaceAll("%C3%B1", "ñ");
  res = res.replaceAll("%C3%BC", "ü");
  res = res.replaceAll("%C3%9C", "Ü");
  console.log(res);
  return res;
}

export function formatName(text) {
  var res = text.replaceAll("/", "-");
  return res;
}
